/**
 * @author SwathiDivya Bhavaraju
 * @email swathidivya.bhavaraju@ul.com
 * @create date 2021-04-22 12:20:41
 * @modify date 2021-04-22 12:20:41
 * @desc [description]
 */
<template>
  <div class="row activity-tracker-tabs m-0">
    <div class="col-xs-12 tabs-left">
      <ul class="nav nav-tabs" role="tablist">
        <li role="presentation" class="nav-item" :class="{active: tabActiveName=='accountinfo'}">
          <span class="nav-link" @click="tabClicked('accountinfo')" role="tab" data-toggle="tab">Account Info</span>
        </li>
        <li role="presentation" class="nav-item" :class="{active: tabActiveName=='users'}">
          <span class="nav-link" @click="tabClicked('users')" role="tab" data-toggle="tab">Users ({{usersCount}})</span>
        </li>
        <li role="presentation" class="nav-item" :class="{active: tabActiveName=='services'}">
          <span class="nav-link" @click="tabClicked('services')" role="tab" data-toggle="tab">Services</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import EventBus from '../../utils/event-bus';

export default {
  props: ['activeItem'],
  data() {
    return {
      tabActiveName: 'accountinfo',
      usersCount: '',
    };
  },
  methods: {
    tabClicked(tab) {
      this.$emit('selectedMenu', tab);
    },
  },
  watch: {
    activeItem() {
      // this.tabActiveName = this.activeItem;
      this.tabClicked(this.activeItem);
    },
  },
  created() {
    EventBus.$on('usersCount', (data) => {
      this.usersCount = data;
    });
  },
};
</script>
